import { Flex, Text, useMantineTheme } from "@mantine/core";
import { Link } from "react-router-dom";

function genLink(
  entityId: string,
  useCaseId: string,
  runId: string,
  runSeq: string,
  access: string,
  value: string,
  data: any,
  component?: string
) {
  let to = "";
  const linkTo: { name: string; value: string } = data.props.find(
    (prop: { name: string; value: string }) => prop.name === "__to"
  );

  if (linkTo.value) {
    to = linkTo.value;
    to = to.replaceAll("${value}", value);
    to = to.replaceAll("${entityId}", entityId);
    to = to.replaceAll("${id}", useCaseId);
    to = to.replaceAll("${runId}", runId);
    to = to.replaceAll("${runSeq}", runSeq);
    to = to.replaceAll("${access}", access);
  }

  return to;
}

export default function DLinks({
  entityId,
  useCaseId,
  runId,
  runSeq,
  access,
  data,
  component,
}: {
  entityId: string;
  useCaseId: string;
  runId: string;
  runSeq: string;
  access: string;
  data: any;
  component?: string;
}) {
  const theme = useMantineTheme();

  const seperator: { name: string; value: string } = data.props.find(
    (prop: { name: string; value: string }) => prop.name === "__seperator"
  );

  const links = data.value1.value.split(seperator ? seperator.value : ",");

  if (links && links.length > 0) {
    return (
      <Flex>
        {links.map((link: string, index: number) => {
          return (
            <Link
              key={index}
              style={{ marginRight: theme.spacing.xxs }}
              to={genLink(
                entityId,
                useCaseId,
                runId,
                runSeq,
                access,
                link,
                data,
                component
              )}
            >
              <Text size={"xs"}>{link}</Text>
            </Link>
          );
        })}
      </Flex>
    );
  } else {
    return <></>;
  }
}
